export const WEBSITE_EDUTALK = 2;
export const TYPE_NOI_BAT = 'highlights';
export const TYPE_THONG_THUONG = 'normal';

